import { Box } from "@chakra-ui/react";
import { FaMicrophone } from "react-icons/fa";

interface AudioThumbnailProps {
  onMouseEnter: () => void;
  isActive: boolean;
}

const AudioThumbnail: React.FC<AudioThumbnailProps> = ({
  onMouseEnter,
  isActive,
}) => {
  return (
    <Box
      height="60px"
      width="100%"
      border={isActive ? "3px solid #0096e0" : "3px solid lightgrey"}
      display="flex"
      alignItems="center"
      justifyContent="center"
      cursor="pointer"
      onMouseEnter={onMouseEnter}
      backgroundColor={isActive ? "#E6F7FF" : "white"}
      transition="all 0.2s"
      _hover={{
        backgroundColor: "#F0F0F0",
        borderColor: "#0096e0",
      }}
    >
      <FaMicrophone
        size={30}
        color={isActive ? "#0096e0" : "#666"}
        style={{ transition: "color 0.2s" }}
      />
    </Box>
  );
};

export default AudioThumbnail;
